import React from 'react';
import DevOpsIcon from '../svg/devops.svg';

const IconDevOps = () => <img src={DevOpsIcon} alt="DevOps Icon" width={64} height={64} />;

export default IconDevOps;
